import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{
    ProductId: string;
    IsActive: boolean;
    QtyOrdered: string;
    ProductERPNumber: string;
    UnitOfMeasure: number;
    updateExistingProduct?: boolean;
    editProductPageFlag?: boolean;
}>;

export const DispatchSetSubscriptionProductIsSelected: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/SetSubscriptionProductIsSelected",
        selectedPorduct: {
            ProductId: props.parameter.ProductId,
            IsActive: props.parameter.IsActive,
            QtyOrdered: props.parameter.QtyOrdered,
            ProductERPNumber: props.parameter.ProductERPNumber,
            UnitOfMeasure: props.parameter.UnitOfMeasure,
            updateExistingProduct: props.parameter.updateExistingProduct,
            editProductPageFlag: props.parameter.editProductPageFlag,
        },
    });
};

export const chain = [DispatchSetSubscriptionProductIsSelected];

const setSubscriptionProductIsSelected = createHandlerChainRunner(chain, "SeSubscriptionProductIsSelected");
export default setSubscriptionProductIsSelected;
